module.exports = __webpack_public_path__ + "static/media/Catering_CnD_Meatloaf_780x390.154c423a.jpg";